import React, { useState, useEffect } from "react";
import { DateRangePicker } from "react-dates";
import moment from "moment";
import CalendarArrowIcon from "./CalendarIcon";

const Calendar = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  focusedInput,
  setFocusedInput,
}) => {
  const [monthsToShow, setMonthsToShow] = useState(2);

  // Responsive months
  useEffect(() => {
    const handleResize = () => {
      setMonthsToShow(window?.innerWidth < 768 ? 1 : 2);
    };

    handleResize();
    window?.addEventListener("resize", handleResize);

    return () => window?.removeEventListener("resize", handleResize);
  }, []);

  const handleDatesChange = ({ startDate, endDate }) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  const handleInputClick = () => {
    setFocusedInput(focusedInput === null ? "startDate" : null);
  };

  const customInputIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 14 14"
      fill="none"
      onClick={handleInputClick}
    >
      <path
        d="M1 6.9375C1 4.58063 1 3.40187 1.7325 2.67C2.46437 1.9375 3.64313 1.9375 6 1.9375H8.5C10.8569 1.9375 12.0356 1.9375 12.7675 2.67C13.5 3.40187 13.5 4.58063 13.5 6.9375V8.1875C13.5 10.5444 13.5 11.7231 12.7675 12.455C12.0356 13.1875 10.8569 13.1875 8.5 13.1875H6C3.64313 13.1875 2.46437 13.1875 1.7325 12.455C1 11.7231 1 10.5444 1 8.1875V6.9375Z"
        stroke="#074073"
      />
      <path
        opacity="0.5"
        d="M4.125 1.9375V1M10.375 1.9375V1M1.3125 5.0625H13.1875"
        stroke="#074073"
        stroke-linecap="round"
      />
      <path
        d="M11 10.0625C11 10.2283 10.9342 10.3872 10.8169 10.5044C10.6997 10.6217 10.5408 10.6875 10.375 10.6875C10.2092 10.6875 10.0503 10.6217 9.93306 10.5044C9.81585 10.3872 9.75 10.2283 9.75 10.0625C9.75 9.89674 9.81585 9.73777 9.93306 9.62056C10.0503 9.50335 10.2092 9.4375 10.375 9.4375C10.5408 9.4375 10.6997 9.50335 10.8169 9.62056C10.9342 9.73777 11 9.89674 11 10.0625ZM11 7.5625C11 7.72826 10.9342 7.88723 10.8169 8.00444C10.6997 8.12165 10.5408 8.1875 10.375 8.1875C10.2092 8.1875 10.0503 8.12165 9.93306 8.00444C9.81585 7.88723 9.75 7.72826 9.75 7.5625C9.75 7.39674 9.81585 7.23777 9.93306 7.12056C10.0503 7.00335 10.2092 6.9375 10.375 6.9375C10.5408 6.9375 10.6997 7.00335 10.8169 7.12056C10.9342 7.23777 11 7.39674 11 7.5625ZM7.875 10.0625C7.875 10.2283 7.80915 10.3872 7.69194 10.5044C7.57473 10.6217 7.41576 10.6875 7.25 10.6875C7.08424 10.6875 6.92527 10.6217 6.80806 10.5044C6.69085 10.3872 6.625 10.2283 6.625 10.0625C6.625 9.89674 6.69085 9.73777 6.80806 9.62056C6.92527 9.50335 7.08424 9.4375 7.25 9.4375C7.41576 9.4375 7.57473 9.50335 7.69194 9.62056C7.80915 9.73777 7.875 9.89674 7.875 10.0625ZM7.875 7.5625C7.875 7.72826 7.80915 7.88723 7.69194 8.00444C7.57473 8.12165 7.41576 8.1875 7.25 8.1875C7.08424 8.1875 6.92527 8.12165 6.80806 8.00444C6.69085 7.88723 6.625 7.72826 6.625 7.5625C6.625 7.39674 6.69085 7.23777 6.80806 7.12056C6.92527 7.00335 7.08424 6.9375 7.25 6.9375C7.41576 6.9375 7.57473 7.00335 7.69194 7.12056C7.80915 7.23777 7.875 7.39674 7.875 7.5625ZM4.75 10.0625C4.75 10.2283 4.68415 10.3872 4.56694 10.5044C4.44973 10.6217 4.29076 10.6875 4.125 10.6875C3.95924 10.6875 3.80027 10.6217 3.68306 10.5044C3.56585 10.3872 3.5 10.2283 3.5 10.0625C3.5 9.89674 3.56585 9.73777 3.68306 9.62056C3.80027 9.50335 3.95924 9.4375 4.125 9.4375C4.29076 9.4375 4.44973 9.50335 4.56694 9.62056C4.68415 9.73777 4.75 9.89674 4.75 10.0625ZM4.75 7.5625C4.75 7.72826 4.68415 7.88723 4.56694 8.00444C4.44973 8.12165 4.29076 8.1875 4.125 8.1875C3.95924 8.1875 3.80027 8.12165 3.68306 8.00444C3.56585 7.88723 3.5 7.72826 3.5 7.5625C3.5 7.39674 3.56585 7.23777 3.68306 7.12056C3.80027 7.00335 3.95924 6.9375 4.125 6.9375C4.29076 6.9375 4.44973 7.00335 4.56694 7.12056C4.68415 7.23777 4.75 7.39674 4.75 7.5625Z"
        fill="#074073"
      />
    </svg>
  );

  // Quick ranges
  const handleCustomRange = (range) => {
    const today = moment();
    let newStartDate, newEndDate;

    switch (range) {
      case "yesterday":
        newStartDate = today.clone().subtract(1, "days");
        newEndDate = today.clone().subtract(1, "days");
        break;

      case "lastWeek":
        newStartDate = today.clone().subtract(1, "weeks").startOf("isoWeek");
        newEndDate = today.clone().subtract(1, "weeks").endOf("isoWeek");
        break;

      case "lastMonth":
        newStartDate = today.clone().subtract(1, "months").startOf("month");
        newEndDate = today.clone().subtract(1, "months").endOf("month");
        break;

      case "lastYear":
        newStartDate = today.clone().subtract(1, "years").startOf("year");
        newEndDate = today.clone().subtract(1, "years").endOf("year");
        break;

      default:
        break;
    }

    setStartDate(newStartDate);
    setEndDate(newEndDate);
    setFocusedInput(null);
  };

  // Year + Month navigator
  const renderMonthElement = ({ month, onMonthSelect, onYearSelect }) => {
    const years = [];

    for (let i = 1990; i <= moment().year() + 5; i++) {
      years?.push(i);
    }

    return (
      <div className="flex gap-2 justify-center items-center">
        <select
          className="border rounded py-0.5 text-sm"
          value={month.month()}
          onChange={(e) => onMonthSelect(month, e.target.value)}
        >
          {moment?.months()?.map((label, value) => (
            <option value={value} key={value}>
              {label}
            </option>
          ))}
        </select>

        <select
          className="border rounded py-0.5 text-sm"
          value={month.year()}
          onChange={(e) => onYearSelect(month, e.target.value)}
        >
          {years?.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
    );
  };

  const renderCustomButtons = () => {
    return (
      <div className="p-[10px] flex flex-wrap gap-3">
        <button
          className="text-[#074073]"
          onClick={() => handleCustomRange("yesterday")}
        >
          Yesterday
        </button>

        <button
          className="text-[#074073]"
          onClick={() => handleCustomRange("lastWeek")}
        >
          Last Week
        </button>

        <button
          className="text-[#074073]"
          onClick={() => handleCustomRange("lastMonth")}
        >
          Last Month
        </button>

        <button
          className="text-[#074073]"
          onClick={() => handleCustomRange("lastYear")}
        >
          Last Year
        </button>
      </div>
    );
  };

  return (
    <>
      <DateRangePicker
        startDate={moment?.isMoment(startDate) ? startDate : null}
        endDate={moment?.isMoment(endDate) ? endDate : null}
        onDatesChange={handleDatesChange}
        focusedInput={focusedInput}
        onFocusChange={(focusedInput) => setFocusedInput(focusedInput)}
        renderCalendarInfo={renderCustomButtons}
        renderMonthElement={renderMonthElement}
        customInputIcon={customInputIcon}
        numberOfMonths={monthsToShow}
        isOutsideRange={(day) => day?.isAfter(moment(), "day")}
        customArrowIcon={CalendarArrowIcon}
        readOnly
        showClearDates
        reopenPickerOnClearDates
      />
    </>
  );
};

export default Calendar;
